import {register} from '@shopify/theme-sections';

const sectionType = 'article-header';

const registeredSections = window.Shopify?.theme?.sections?.registered || {};
const isUnregistered = typeof registeredSections[sectionType] === 'undefined';

const classes = {
  sticky: 'article-header--sticky',
};

export default isUnregistered &&
  register(sectionType, {
    onLoad() {
      const container = this.container;
      const settingsAttr = container.dataset?.sectionSettings || '{}';
      const settings = JSON.parse(settingsAttr);
      const {isSticky, hasStickyStop} = settings;

      if (isSticky) {
        container.parentElement.classList.add(classes.sticky);
      }

      if (!isSticky || !hasStickyStop) return;

      // Stop sticky functionality after user has scrolled past first section
      const secondSection = document.getElementById('MainContent')?.firstElementChild?.nextSibling;
      if (!secondSection) return;

      const validSectionClasses = [
        'hero-banner-section',
        'hero-slider-section',
        'article-featured-image',
        'video-banner',
        'image-banners',
      ];
      const isValidSection = validSectionClasses.some((validClass) => secondSection.classList.contains(validClass));

      if (!isValidSection) {
        container.parentElement.classList.remove(classes.sticky);
        return;
      }

      const desktopQuery = window.matchMedia(`(min-width: ${window.theme.breakpoints.lg}px)`);

      const positionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            container.parentElement.classList.toggle(classes.sticky, entry.isIntersecting);
          });
        },
        {rootMargin: `-${secondSection.offsetHeight}px 0px`}
      );

      if (desktopQuery.matches) {
        positionObserver.observe(secondSection);
      }

      // Connect / disconnect observer when media query changes
      desktopQuery.addEventListener('change', (event) => {
        if (event.matches) {
          positionObserver.observe(secondSection);
          return;
        }

        positionObserver.disconnect();
      });
    },
  });
